// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a492ffeb","489":"e74e8a59","755":"5f0105c5"}[chunkId] + ".chunk.js";
};